export default "__VITE_PUBLIC_ASSET__582533c1__"